'use client';

import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import Image from 'next/image';
import { useEffect, useRef, useState } from 'react';
import { useCalculateUsage } from '@/app/cc/_apis/UsageCalculator/useCalculateUsage';
import Button from '@/app/cc/_component/ui/common/Button/Button';
import Text from '@/app/cc/_component/ui/common/Text/Text';
import styles from '@/app/cc/_component/ui/section/Differences/Differences.module.scss';
import { formatWithCommas } from '@/app/cc/_util/formatWithCommas';
import { numberToKorean } from '@/app/cc/_util/numberToKorean';
import { sendGA } from '@/app/cc/_util/sendGA';
import { stripNonDigits } from '@/app/cc/_util/stripNonDigits';
export default function UsageCalculator(t0) {
  const $ = _c(55);
  const {
    dealType
  } = t0;
  const [usage, setUsage] = useState("");
  const [prevDealType, setPrevDealType] = useState(dealType);
  if (prevDealType !== dealType) {
    setPrevDealType(dealType);
    setUsage("");
  }
  const inputRef = useRef(null);
  const {
    mutate,
    isPending,
    data: calculatorResult,
    reset
  } = useCalculateUsage();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = e => {
      setUsage(prev => stripNonDigits(prev, e.target.value, 12));
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleUsageChange = t1;
  let t2;
  if ($[1] !== dealType || $[2] !== mutate || $[3] !== usage) {
    t2 = () => {
      if (usage === "") {
        inputRef.current?.focus();
        return;
      }
      sendGA(dealType === "rent" ? "calculateRentUsage" : "calculateSaleUsage");
      mutate({
        price: Number(usage),
        dealType
      });
    };
    $[1] = dealType;
    $[2] = mutate;
    $[3] = usage;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleCalculatorResult = t2;
  let t3;
  if ($[5] !== reset) {
    t3 = () => {
      setUsage("");
      reset();
    };
    $[5] = reset;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleResetResult = t3;
  let t4;
  let t5;
  if ($[7] !== dealType || $[8] !== reset) {
    t4 = () => {
      if (dealType) {
        reset();
      }
    };
    t5 = [dealType, reset];
    $[7] = dealType;
    $[8] = reset;
    $[9] = t4;
    $[10] = t5;
  } else {
    t4 = $[9];
    t5 = $[10];
  }
  useEffect(t4, t5);
  const t6 = dealType === "rent" ? styles.usageCalculatorRent : styles.usageCalculatorSale;
  let t7;
  if ($[11] !== t6) {
    t7 = clsx(styles.usageCalculator, t6);
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== calculatorResult || $[14] !== dealType) {
    t8 = dealType === "rent" && <Text as="p" category="title" variant="b3" color="var(--color-gray-900)">{calculatorResult ? "\uC548\uC2EC\uCF00\uC5B4 \uC774\uC6A9\uB8CC\uB97C \uD655\uC778\uD574 \uBCF4\uC138\uC694!" : "\uB0B4 \uC548\uC2EC\uCF00\uC5B4 \uC774\uC6A9\uB8CC\uB294?"}</Text>;
    $[13] = calculatorResult;
    $[14] = dealType;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const t9 = dealType === "rent" ? styles.calculaterInputRent : styles.calculaterInputSale;
  let t10;
  if ($[16] !== usage) {
    t10 = formatWithCommas(usage);
    $[16] = usage;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  const t11 = dealType === "rent" ? "\uB0B4 \uBCF4\uC99D\uAE08\uC744 \uC785\uB825\uD558\uC138\uC694" : "\uB0B4 \uB9E4\uB9E4\uAC00\uB97C \uC785\uB825\uD558\uC138\uC694";
  const t12 = calculatorResult !== undefined;
  let t13;
  if ($[18] !== t10 || $[19] !== t11 || $[20] !== t12 || $[21] !== t9) {
    t13 = <input ref={inputRef} autoComplete="off" className={t9} type="text" inputMode="numeric" name="usage" value={t10} onChange={handleUsageChange} placeholder={t11} disabled={t12} />;
    $[18] = t10;
    $[19] = t11;
    $[20] = t12;
    $[21] = t9;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  const t14 = dealType === "rent" ? "sb1" : "sb2";
  let t15;
  if ($[23] !== t14) {
    t15 = <Text as="p" category="heading" variant={t14} color="var(--color-gray-700)">원</Text>;
    $[23] = t14;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== t13 || $[26] !== t15) {
    t16 = <div className={styles.inputContainer}>{t13}{t15}</div>;
    $[25] = t13;
    $[26] = t15;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== usage) {
    t17 = numberToKorean(usage);
    $[28] = usage;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== t17) {
    t18 = <Text category="heading" variant="m3" color="var(--color-gray-400)">{t17}</Text>;
    $[30] = t17;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Text category="heading" variant="m3" color="var(--color-gray-400)">원</Text>;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] !== t18) {
    t20 = <div className={styles.usageKoreanContainer}>{t18}{t19}</div>;
    $[33] = t18;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== t16 || $[36] !== t20) {
    t21 = <div className={styles.usageCalculatorContent}>{t16}{t20}</div>;
    $[35] = t16;
    $[36] = t20;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  if ($[38] !== calculatorResult || $[39] !== dealType || $[40] !== usage) {
    t22 = calculatorResult && <div className={styles.calculatorResult}><div className={styles.calculatorResultItem}><Text category="heading" variant="m3" color="var(--color-gray-600)">{dealType === "rent" ? "\uBCF4\uC99D\uAE08" : "\uB9E4\uB9E4\uAC00"}</Text><Text category="heading" variant="m3" color="var(--color-gray-600)">{formatWithCommas(usage)}원</Text></div><div className={styles.calculatorResultItem}><Text category="heading" variant="m3" color="var(--color-gray-600)">서비스 이용료</Text><div><Text category="heading" variant="m3" color="var(--color-red-500)">{formatWithCommas(calculatorResult.price.discountPrice?.toString() ?? calculatorResult.price.paymentPrice.toString())}</Text><Text category="heading" variant="m3" color="var(--color-gray-600)">원</Text></div></div></div>;
    $[38] = calculatorResult;
    $[39] = dealType;
    $[40] = usage;
    $[41] = t22;
  } else {
    t22 = $[41];
  }
  let t23;
  if ($[42] !== t21 || $[43] !== t22) {
    t23 = <div className={styles.calculatorContent}>{t21}{t22}</div>;
    $[42] = t21;
    $[43] = t22;
    $[44] = t23;
  } else {
    t23 = $[44];
  }
  let t24;
  if ($[45] !== calculatorResult || $[46] !== handleCalculatorResult || $[47] !== handleResetResult || $[48] !== isPending) {
    t24 = <div className={styles.buttonContainer}>{calculatorResult ? <Button type="button" onClick={handleResetResult}><Text as="span" category="heading" variant="sb2" color="var(--color-gray-0)">초기화</Text><Image src="/cc/image/icon_reset.svg" alt="reset_icon" width={24} height={24} /></Button> : <Button type="button" onClick={handleCalculatorResult} disabled={isPending}><Text as="span" category="heading" variant="sb2" color="var(--color-gray-0)">1초 만에 조회</Text><Image src="/cc/image/icon_search.svg" alt="search_icon" width={24} height={24} /></Button>}</div>;
    $[45] = calculatorResult;
    $[46] = handleCalculatorResult;
    $[47] = handleResetResult;
    $[48] = isPending;
    $[49] = t24;
  } else {
    t24 = $[49];
  }
  let t25;
  if ($[50] !== t23 || $[51] !== t24 || $[52] !== t7 || $[53] !== t8) {
    t25 = <div className={t7}>{t8}{t23}{t24}</div>;
    $[50] = t23;
    $[51] = t24;
    $[52] = t7;
    $[53] = t8;
    $[54] = t25;
  } else {
    t25 = $[54];
  }
  return t25;
}